import { Loader2 } from "lucide-react";

export const FullScreenLoader = () => (
  <div className="flex h-screen items-center justify-center bg-slate-50" data-testid="app-loader">
    <Loader2 className="h-6 w-6 animate-spin text-teal-600" />
  </div>
);
